// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"AttachmentUpload_imgWrapper__10uQJ","img":"AttachmentUpload_img__1815E"};